import React, { FC } from "react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import { useTranslation } from "react-i18next";

export interface CardGuidesProps {
  className?: string;
  taxonomy: any;
  categories?: any;
}

const CardGuides: FC<CardGuidesProps> = ({
  className = "",
  taxonomy,
}) => {
  const { t } = useTranslation();

  const { nom, code } = taxonomy;

  return (
    <Link
      to={`${t("lienGuide")}/${code}`}
      className={`
        group
        relative
        block
        min-w-[260px]
        overflow-hidden
        rounded-[1.6rem]
        bg-white
        shadow-[0_18px_45px_rgba(15,23,42,0.08)]
        ring-1
        ring-slate-900/5
        transition-all
        duration-300
        hover:-translate-y-1
        hover:shadow-[0_24px_60px_rgba(124,58,237,0.16)]
        dark:bg-slate-900
        dark:ring-white/10
        ${className}
      `}
      data-nc-id="CardGuides"
    >
      <div className="relative h-32 overflow-hidden">
        <NcImage
          src={require(`../../images/countries/${code}.webp`)}
          containerClassName="absolute inset-0"
          className="
            h-full
            w-full
            object-cover
            transition-transform
            duration-500
            group-hover:scale-105
          "
        />
        
      </div>

     <div
  className="
    flex
    min-h-[54px]
    items-center
    gap-3
    bg-white
    px-4
    py-2
    dark:bg-slate-900
  "
>


        <div className="min-w-0">
          <h2
            className="
              truncate
              text-base
              font-black
              text-slate-950
              dark:text-white
            "
          >
            {nom}
          </h2>


        </div>
      </div>
    </Link>
  );
};

export default CardGuides;